import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'oiq-sms-messaging-dialog',
  templateUrl: './sms-messaging-dialog.component.html',
  styleUrls: ['./sms-messaging-dialog.component.scss'],
  standalone: false,
})
export class SmsMessagingDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<SmsMessagingDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {}

  close() {
    this.dialogRef.close(true);
  }
}
